import { FunnelChart } from '@wundo/ui';
import type { MetricDataPoint } from '@/lib/dashboard.ts';
import { ChartCard } from './ChartCard.tsx';
import { formatPct, sumPoints } from './funnelMath.ts';

export interface MeetingDocumentFunnelCardProps {
  title: string;
  /** What the first step is called: a preparation is generated, a report created. */
  madeLabel: string;
  made: MetricDataPoint[];
  opened: MetricDataPoint[];
  info: string;
}

/**
 * How many of a meeting document that came into being were read. Opened is
 * counted once per person per meeting per day, so it can outrun the first
 * step when people come back to a document on another day.
 */
export function MeetingDocumentFunnelCard(props: MeetingDocumentFunnelCardProps) {
  const made = sumPoints(props.made);
  const opened = sumPoints(props.opened);

  return (
    <ChartCard
      title={props.title}
      info={props.info}
      description={`${props.madeLabel} → Opened, summed over the period.`}
      aside={
        <p className='text-xs text-ink-muted'>
          {`Opened ÷ ${props.madeLabel.toLowerCase()}: ${formatPct(opened, made)}`}
        </p>
      }
    >
      <FunnelChart
        ariaLabel={props.title}
        steps={[
          { label: props.madeLabel, value: made },
          { label: 'Opened', value: opened },
        ]}
      />
    </ChartCard>
  );
}
